<script setup lang="ts">
import { twMerge } from "tailwind-merge";

import { useUser } from "@/composables/api/useUser";

import Spinner from "@/components/ui/Spinner.vue";

const { data: user, isError } = useUser();
</script>

<template>
  <main
    class="flex min-h-svh flex-col items-center justify-center gap-4"
    role="main"
    aria-live="polite"
  >
    <h1
      :class="
        twMerge(
          'text-galbani text-center text-xl font-medium',
          user?.current_mechanic === 'lactel' && 'text-lactel-blue',
        )
      "
    >
      Connexion en cours...
    </h1>

    <Spinner />

    <p v-if="isError" class="text-error text-center text-base font-medium">
      Une erreur est survenue. Veuillez réessayer.
    </p>
  </main>
</template>
